module.exports = __webpack_public_path__ + "static/media/ZHT0062-3.ed892ad9.png";